const GoodAsYou = [
	'[Verse 1]',
	"See the way you're taking care of your Mama",
	'The way you’re taking care of me',
	'The way you light up any room, girl',
	"You're what this world should be",
	'',
	'[Pre-Chorus]',
	'Tomorrow, tonight, the rest of my life',
	'I wanna be the man you want me to be',
	'So start right now, girl,',
	'tell me everything you need',
	'',
	'[Chorus]',
	'I just wanna wake up everyday here in this bed',
	"Never leave 'I love you' left unsaid",
	'It might take a hundred lifetimes to do',
	'But baby, I just wanna be good as you',
	'',
	'[Verse 2]',
	"Girl, you're more than just the surface",
	'Yeah, you got that heart of gold',
	'So when it comes to loving you, baby',
	'No, it will never get old',
	'',
	'[Pre-Chorus]',
	'Tomorrow, tonight, the rest of my life',
	'I wanna be the man you want me to be',
	'So start right now, girl,',
	'tell me everything you need',
	'',
	'[Chorus]',
	'I just wanna wake up everyday here in this bed',
	"Never leave 'I love you’ left unsaid",
	'It might take a hundred lifetimes to do',
	'But baby, I just wanna be good as you',
	'Good as you, baby',
	'',
	'[Chorus]',
	'I just wanna wake up everyday here in this bed',
	'Never leave I love you left unsaid',
	'It might take a hundred lifetimes to do',
	'But baby, I just wanna be good as you',
	'',
	'I just wanna wake up everyday here in this bed',
	'Never leave I love you left unsaid',
	'It might take a hundred lifetimes to do',
	'But baby, I just wanna be good as you',
	'Baby, I just wanna be good as you',
];

export default GoodAsYou;
